import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/workpath0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Installation`}</h1>
    <h2>{`Artifact`}</h2>
    <p>{`Tesfy is available through `}<a parentName="p" {...{
        "href": "https://search.maven.org/artifact/io.tesfy/tesfy-kotlin"
      }}>{`Maven Central`}</a>{`. To install it, simply add the dependency depending on your build tool:`}</p>
    <h3>{`Gradle`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-kt"
      }}>{`implementation("io.tesfy:tesfy-kotlin")
`}</code></pre>
    <h3>{`Maven`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<dependency>
  <groupId>io.tesfy</groupId>
  <artifactId>tesfy-kotlin</artifactId>
  <version>1.0</version>
</dependency>
`}</code></pre>
    <h2>{`Initialization`}</h2>
    <p>{`Once imported, instantiate the engine with a `}<inlineCode parentName="p">{`datafile`}</inlineCode>{`, you can pass as an userId a fixed userId or `}<inlineCode parentName="p">{`null`}</inlineCode>{` (it can be defined later), a Map<String, Any> with attributes,
an optional implementation of the `}<inlineCode parentName="p">{`storage`}</inlineCode>{` interface to enable sticky bucketing.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kt"
      }}>{`val datafile = Datafile(
  mapOf(
    "experiment-1" to Experiment(
      "experiment-1",
      100,
      listOf(
        Variation(
          "0", 50
        ),
        Variation(
          "1", 50
        )
      ),
      mapOf(
        "==" to listOf(mapOf(
          "var" to "countryCode"
        ), "us")
      )
    )
  ),
  mapOf()
)
val userId = "4qz936x2-62ex"
val attributes = mapOf("countryCode" to "us")
val engine = Engine(datafile, userId, attributes, storage)

val variationId = engine.getVariationId("experiment-1", userId, attributes)
`}</code></pre>
    <h2>{`Datafile creation`}</h2>
    <p>{`When a datafile is initialised, you may create experiments inside it. To create an experiment you have to provide an audience, the audience field can be defined in 2 different ways.`}</p>
    <h3>{`Audience definition as Map`}</h3>
    <p>{`To instantiate a Datafile using a Map for audience you could follow this piece of code:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kt"
      }}>{`val datafile = Datafile(
  mapOf(
    "experiment-1" to Experiment(
      "experiment-1",
      100,
      listOf(
        Variation(
          "0", 75
        ),
        Variation(
          "1", 25
        )
      ),
      mapOf(
        "==" to listOf(mapOf(
          "var" to "countryCode"
        ), "nl")
      )
    )
  ),
  mapOf()
)
`}</code></pre>
    <h3>{`Audience definition as String`}</h3>
    <p>{`To instantiate a Datafile using a String for audience you could follow this piece of code:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kt"
      }}>{`Datafile(
    mapOf(
        "experiment-1" to Experiment(
            "experiment-1",
            100,
            listOf(
                Variation(
                    "0", 30
                ),
                Variation(
                    "1", 70
                )
            ),
            """{ "==": [{ var: 'countryCode' }, ve]}"""
        )
    ),
    mapOf()
)
`}</code></pre>
    <p>{`The string that you pass in the audience field have to be a properly defined JSONLogic`}</p>
    <h2>{`Considerations`}</h2>
    <p>{`This version of the library is using Unsigned Integers from Kotlin and currently is in Beta,
for more information please read the `}<a parentName="p" {...{
        "href": "https://kotlinlang.org/docs/reference/basic-types.html#beta-status-of-unsigned-integers"
      }}>{`following link`}</a>{`.`}</p>
    <p>{`According to our tests in all of our implementations for different languages, the results are exactly the same.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      